<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.index.title`)"
    :toasts="toasts"
    :resource="models"
  >
    <div class="model-title-bar">
      <div class="flex row pe-2">
        <div class="col flex-grow-1">
          <h2 class="fw-bold text-uppercase p-1">
            {{ trans(`models.${resourceType}.content.index.title`) }}
          </h2>
        </div>

        <resource-action-buttons
          :button-class="'btn btn-primary text-secondary'"
          :model="getMetaDummy()"
          :resource-type="resourceType"
          :source-action="'index'"
        ></resource-action-buttons>
      </div>
      <div v-if="hasDescription(trans)" class="card rounded-corner">
        <div class="card-body">
          <p class="card-text">
            {{ trans(`models.${resourceType}.content.index.description`) }}
          </p>
        </div>
      </div>
      <div class="pb-3">
        <component
          :is="customActionBox(aspect)"
          :data="customActionData"
          :params="getIndexParams()"
          :resource-type="resourceType"
          :route="route(`${routePrefix}.${resourceType}.adjust`, getIndexParams())"
        ></component>
      </div>
    </div>
    <div class="card rounded-corner">
      <div class="card-body position-relative">
        <resource-collection
          :collection-type="models.meta.config.component?.type ?? 'list'"
          :mode="'full'"
          :models="models"
          :pagination="false"
          @add-toast="addToast"
        ></resource-collection>
        <div v-if="models.page" class="admin-footer mt-3">
          <pagination :name="trans(`models.${resourceType}.name.plural`)" :resource="models"></pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/structures/moviary/Pages/Layout';
import Pagination from '@/structures/default/components/Pagination';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import ResourceCollection from '@/structures/default/components/ResourceCollection';
import useCustomActionBox from '@/structures/default/composables/useCustomActionBox';
import useResourceParams from '@/structures/default/composables/useResourceParams';
import useResource from '@/structures/default/composables/useResource';
import useToasts from '@/structures/default/composables/useToasts';

export default {
  components: {
    Layout,
    Pagination,
    ResourceActionButtons,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    models: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    config: { type: Object, default: () => {} },
    adjustments: { type: Object, default: () => {} },
    sort: { type: String, default: () => 'id' },
    filter: { type: Object, default: () => {} },
    excludeNull: { type: Object, default: () => {} },
    customActionData: { type: Object, default: () => {} },
  },
  setup(props) {
    const { resourceType } = useResource(props, props.models);
    const { customActionBox } = useCustomActionBox(props);
    const { addToast } = useToasts(props);
    const { getIndexParams } = useResourceParams(props);

    const getMetaDummy = () => {
      return {
        data: [],
        meta: props.models.meta,
      };
    };

    const hasDescription = (trans) => {
      let transString = `models.${resourceType.value}.content.index.description`;
      let translation = trans(transString);

      return translation && translation !== transString;
    };

    return {
      addToast,
      customActionBox,
      getMetaDummy,
      getIndexParams,
      hasDescription,
      resourceType,
    };
  },
};
</script>
